import { z as zod } from 'zod';

export const contentBlockSchema = zod.object({
  title: zod.string(),
  subtitle: zod.string(),
  published: zod.boolean(),
});
